import { Typography } from "@material-ui/core";
import React from "react";
import useWindowDimensions from "../../hooks/useWindowDimension";
import { XL_BREAKPOINT } from "../../config/breakpoints";

const BreadCrumbsBar = (props) => {
  const { breadcrumbsRight, breadCrumbsTitle, breadCrumbsSubTitle } = props;
  const { width } = useWindowDimensions();

  const styles = {
    container: {
      width: "100%",
      height: "100%",
      paddingTop: 20,
      paddingBottom: 20,
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
      justifyContent: "center",
      backgroundColor: "#f4f4f4",
    },
    contentContainer: {
      width: width > XL_BREAKPOINT ? "65%" : "90%",
      height: "90%",
      display: "flex",
      alignItems: "center",
      justifyContent: width > XL_BREAKPOINT ? "space-between" : "center",
    },
    leftContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
    rightContainer: {
      width: width > XL_BREAKPOINT ? "40%" : "90%",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentContainer}>
        {width > XL_BREAKPOINT && (
          <div style={styles.leftContainer}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: "500",
                  }}
                >
                  {breadCrumbsTitle}
                </Typography>
              </div>
            </div>
            <Typography variant="h5">
              {breadCrumbsSubTitle && breadCrumbsSubTitle}
            </Typography>
          </div>
        )}
        <div style={styles.rightContainer}>{breadcrumbsRight()}</div>
      </div>
    </div>
  );
};

export default BreadCrumbsBar;
